import React from "react";
import { ActivePartnerContext } from "./context";
import vdcom from "lib/vd";
import Preloader from "components/preloader";

export const ActivePartnerProvider = ({ children }) => {
  const [error, setError] = React.useState(null);
  const [activePartner, setActivePartner] = React.useState(null);

  React.useEffect(() => {
    vdcom
      .partner()
      .activePartner()
      .then((response) => {
        setActivePartner(response);
      })
      .catch((error) => {
        console.error("FINDME-Failed to fetch active partner", error);
      });
  }, []);

  if (!activePartner) {
    return <Preloader />;
  }

  return (
    <ActivePartnerContext.Provider
      value={{ partner: activePartner, setActivePartner }}
    >
      {children}
    </ActivePartnerContext.Provider>
  );
};
